/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const ChevronDown = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 8 5">
      <path
        d="M2.5,6 C2.372,6 2.244,5.951 2.146,5.854 C1.951,5.658 1.951,5.342 2.146,5.146 L4.793,2.5 L2.146,-0.146 C1.951,-0.342 1.951,-0.658 2.146,-0.854 C2.342,-1.049 2.658,-1.049 2.854,-0.854 L5.854,2.146 C6.049,2.342 6.049,2.658 5.854,2.854 L2.854,5.854 C2.756,5.951 2.628,6 2.5,6"
        transform="rotate(90 4 2.5)"
      />
    </BaseSvgIcon>
  )
}

export default ChevronDown
